export interface CheckMarkIconProps {
  color?: string;
  fillColor?: string;
}

export const CheckMarkIcon = (props: CheckMarkIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" fill={props.fillColor ?? '#131313'} />
    <path
      d="M15.669 9.25672C16.0795 9.62618 16.1128 10.2585 15.7433 10.669L12.1433 14.669C11.9598 14.8729 11.7005 14.9925 11.4263 14.9997C11.152 15.0069 10.8869 14.9011 10.6929 14.7071L8.29289 12.3071C7.90237 11.9166 7.90237 11.2834 8.29289 10.8929C8.68342 10.5024 9.31658 10.5024 9.70711 10.8929L11.3618 12.5476L14.2567 9.33105C14.6262 8.92054 15.2585 8.88726 15.669 9.25672Z"
      fill={props.color ?? 'white'}
    />
  </svg>
);
